import { render, staticRenderFns } from "./BrandingStep.vue?vue&type=template&id=42de4f08&scoped=true"
import script from "./BrandingStep.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandingStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BrandingStep.vue?vue&type=style&index=0&id=42de4f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42de4f08",
  null
  
)

export default component.exports